const WORLD_MAP_URL = "https://static.prod-images.emergentagent.com/jobs/3295ae7a-aa61-4b86-a313-223ed75a0073/images/3e4d245464980cd75f61d0160e90a7caadfb7d7ba7fd746a5cf2a6917527271a.jpeg";

export function CityMapPanel({ cities }) {
  const points = cities.filter((c) => typeof c.lat === "number" && typeof c.lon === "number");
  const maxVolume = Math.max(...points.map((p) => p.views + p.clicks), 1);

  return (
    <div className="relative w-full rounded-xl overflow-hidden border border-white/10 bg-[#0B0E14]" style={{ aspectRatio: "2 / 1" }} data-testid="city-map-view">
      <img src={WORLD_MAP_URL} alt="World map" className="absolute inset-0 w-full h-full object-cover" />
      {points.length === 0 ? (
        <div className="absolute inset-0 flex items-center justify-center">
          <p className="text-xs text-slate-500">No geolocated traffic yet</p>
        </div>
      ) : (
        points.map((p) => {
          const left = ((p.lon + 180) / 360) * 100;
          const top = ((90 - p.lat) / 180) * 100;
          const volume = p.views + p.clicks;
          const size = 8 + (volume / maxVolume) * 18;
          return (
            <div
              key={p.city}
              className="absolute -translate-x-1/2 -translate-y-1/2 group"
              style={{ left: `${left}%`, top: `${top}%` }}
              data-testid={`city-map-dot-${p.city}`}
            >
              <div
                className="rounded-full bg-emerald-400/80 ring-2 ring-emerald-300/40 animate-pulse"
                style={{ width: size, height: size }}
              />
              <div className="absolute left-1/2 -translate-x-1/2 bottom-full mb-1 hidden group-hover:block whitespace-nowrap rounded-md bg-black/90 text-white text-[11px] px-2 py-1 z-10">
                {p.city} · {p.views} views · {p.clicks} clicks
              </div>
            </div>
          );
        })
      )}
    </div>
  );
}
